const INITIAL_STATE = {
    quiz: [],
    count: 0,
    loading: false
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case "GET_QUIZ": {
        return {
          ...state,
          quiz: action.quiz,
          count: action.count,
          loading: false
        }
      }
      default:
        return state
    }
  }
  